import React from "react";
import { Routes, Route } from "react-router-dom";
import NoFound from "../components/app/NoFound";
import CreateArticle from "../components/inventory/article/form/CreateArticle";
import ArticleIndex from "../components/inventory/article/index/ArticleIndex";
import EntryForm from "../components/inventory/entry/form/EntryForm";
import EntryIndex from "../components/inventory/entry/index/EntryIndex";
import CreateTest from "../components/inventory/test/form/CreateTest";
import TestExit from "../components/inventory/test/form/TestExit";
import TestIndex from "../components/inventory/test/index/TestIndex";
import TestIndexActive from "../components/inventory/test/index/TestIndexActive";
import Login from "../components/security/Login";
import ArticleFormProvider from "../context/inventory/ArticleFormProvider";
import ArticleIndexProvider from "../context/inventory/ArticleIndexProvider";
import EntryFormProvider from "../context/inventory/EntryFormProvider";
import EntryIndexProvider from "../context/inventory/EntryIndexProvider";
import TestExitProvider from "../context/inventory/TestFormExitProvider";
import TestFormProvider from "../context/inventory/TestFormProvider";
import TestIndexActiveProvider from "../context/inventory/TestIndexActiveProvider";
import TestIndexProvider from "../context/inventory/TestIndexProvider";
import ProtectedRoutes from "./ProtectedRoutes";
import ResetPassword from "../components/security/ResetPassword";
import EmailPassword from "../components/security/EmailPassword";
import HandOutFormProvider from "../context/inventory/HandOutFormProvider";
import CreateHandOut from "../components/inventory/handOut/form/CreateHandOut";
import { WarehouseIndexProvider } from "../context/inventory/WarehouseIndexProvider";
import { WarehouseIndex } from "../components/inventory/warehouse/index/WarehouseIndex";
import { ProvidersIndexProvider } from "../context/inventory/ProvidersIndexProvider";
import { ProvidersIndex } from "../components/inventory/provider/index/ProvidersIndex";
import { UserIndexProvider } from "../context/security/UserIndexProvider";
import { UsersIndex } from "../components/security/users/UsersIndex";
import { OutIndexProvider } from "../context/inventory/OutIndexProvider";
import { HandOutIndex } from "../components/inventory/handOut/index/HandOutIndex";
import InventoryArticlesByWarehouseProvider from "../context/inventory/InventoryArticlesByWarehouseProvider";
import { InventoryArticlesByWarouseIndex } from "../components/inventory/inventoryByWarehouse/InventoryArticlesByWarouseIndex";


const Router = () => {
  return (
    <Routes>
      <Route path="/resetPassword/:token" element={<ResetPassword />} />
      <Route path="/mailResetPassword" element={<EmailPassword />} />

      {/*  PROTECTED ROUTES */}
      <Route element={<ProtectedRoutes />}>
        <Route
          path="/inventory/entry"
          element={
            <EntryFormProvider>
              <EntryForm />
            </EntryFormProvider>
          }
        />
        <Route
          path="/inventory/entry/:entry_id"
          element={
            <EntryFormProvider>
              <EntryForm />
            </EntryFormProvider>
          }
        />
        <Route
          path="/inventory/entries"
          element={
            <EntryIndexProvider>
              <EntryIndex />
            </EntryIndexProvider>
          }
        />
        <Route
          path="/inventory/articles"
          element={
            <ArticleFormProvider>
              <ArticleIndexProvider>
                <ArticleIndex />
              </ArticleIndexProvider>
            </ArticleFormProvider>
          }
        />
        <Route
          path="/inventory/article/:item_id"
          element={
            <ArticleFormProvider>
              <CreateArticle />
            </ArticleFormProvider>
          }
        />
        <Route
          path="/inventory/tests"
          element={
            <TestFormProvider>
              <TestIndexProvider>
                <TestIndex />
              </TestIndexProvider>
            </TestFormProvider>
          }
        />
        <Route
          path="/inventory/test/:test_id/exit"
          element={
            <TestExitProvider>
              <TestExit />
            </TestExitProvider>
          }
        />
        <Route
          path="/inventory/test/:test_id/exit/:movement_id"
          element={
            <TestExitProvider>
              <TestExit />
            </TestExitProvider>
          }
        />
        <Route path="/inventory/handOut"
          element={
            <HandOutFormProvider>
              <CreateHandOut />
            </HandOutFormProvider>
          }
        />
        <Route path="/inventory/handOut/:movement_id"
          element={
            <HandOutFormProvider>
              <CreateHandOut />
            </HandOutFormProvider>
          }
        />
        <Route
          path="/inventory/tests-active"
          element={
            <TestIndexActiveProvider>
              <TestIndexActive />
            </TestIndexActiveProvider>
          }
        />
        <Route
          path="/inventory/test"
          element={
            <TestFormProvider>
              <CreateTest />
            </TestFormProvider>
          }
        />
        <Route
          path="/inventory/test/:test_id"
          element={
            <TestFormProvider>
              <CreateTest />
            </TestFormProvider>
          }
        />
        <Route
          path="/inventory/test/new_test/:parent_id"
          element={
            <TestFormProvider>
              <CreateTest />
            </TestFormProvider>
          }
        />
        <Route
          path="/inventory/warehouse"
          element={
            <WarehouseIndexProvider>
              <WarehouseIndex />
            </WarehouseIndexProvider>
          }
        />
        <Route
          path="/inventory/providers"
          element={
            <ProvidersIndexProvider>
              <ProvidersIndex />
            </ProvidersIndexProvider>
          }
        />
        <Route
          path="/security/users"
          element={
            <UserIndexProvider>
              <UsersIndex />
            </UserIndexProvider>
          }
        />

        <Route path="/inventory/handOuts"
          element={
            <OutIndexProvider>
              <HandOutIndex />
            </OutIndexProvider>
          }
        />

        <Route
          path="/inventory/articlesbywarehouse"
          element={
            <InventoryArticlesByWarehouseProvider>
              <InventoryArticlesByWarouseIndex />
            </InventoryArticlesByWarehouseProvider>
          }
        />

        <Route path="/account" element={<Login />} />
      </Route>
      <Route path="/login" element={<Login />} />

      <Route path="*" element={<NoFound />} />
    </Routes>
  );
};

export default Router;
